/**
 * Derives an avatar string from a contact's name or email.
 *
 * - If a non-empty name is provided, returns up to two uppercase initials
 *   from the first and last word (e.g. "John Archer" → "JA").
 * - Otherwise returns the first letter of the email's local-part, uppercased
 *   (e.g. "r.rodriguez@x.com" → "R").
 * - Falls back to "?" if neither is meaningful.
 */
export function getCxpContactInitials(name: string | null | undefined, email: string | null | undefined): string {
  const trimmedName = name?.trim();
  if (trimmedName) {
    const parts = trimmedName.split(/\s+/);
    const first = parts[0]?.[0] ?? '';
    const last = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? '' : '';
    return (first + last).toUpperCase();
  }

  const trimmedEmail = email?.trim();
  if (trimmedEmail) {
    return (trimmedEmail[0] ?? '?').toUpperCase();
  }

  return '?';
}
